import React from 'react'
import { useDispatch } from 'react-redux'
import * as Yup from 'yup'
import { Container } from '@mui/material'
import AppForm from '../form/AppForm'
import AppInput from '../form/AppInput'
import SubmitButton from '../form/SubmitButton'
import Header from '../form/Header'
import { formTypeList } from '../../constants/form'
import {
    addNewItemStyle,
    updateItemStyle,
} from '../../store/actions/itemStyleAction'

const validationSchema = Yup.object().shape({
    name: Yup.string().required().label('Name'),
})

const Form = ({
    formType,
    setOpen,
    itemCategoryId = null,
    propsValue = null,
}) => {
    const dispatch = useDispatch()
    return (
        <Container>
            <Header
                title={`${formType === formTypeList.NEW ? 'ADD' : ''}${
                    formType === formTypeList.EDIT ? 'EDIT' : ''
                } ITEM STYLE`}
            />
            <AppForm
                initialValues={{
                    name: propsValue ? propsValue.name : '',
                    description: propsValue ? propsValue.description : '',
                }}
                onSubmit={(values) => {
                    const submitValues =
                        formType === formTypeList.NEW
                            ? { ...values, itemCategoryId }
                            : { ...propsValue, ...values }
                    formType === formTypeList.NEW
                        ? dispatch(
                              addNewItemStyle(submitValues),
                              setOpen(false)
                          )
                        : dispatch(
                              updateItemStyle(submitValues),
                              setOpen(false)
                          )
                }}
                validationSchema={validationSchema}
            >
                <AppInput
                    name="name"
                    label="Name"
                    type="text"
                    inputProps={{
                        maxLength: 100,
                    }}
                    required={true}
                />
                <AppInput
                    name="description"
                    label="Description"
                    type="text"
                    inputProps={{
                        maxLength: 250,
                    }}
                />
                <SubmitButton title="Submit" />
            </AppForm>
        </Container>
    )
}

export default Form
